import { render, staticRenderFns } from "./dualAxisChart.vue?vue&type=template&id=6d4d95e8&scoped=true&lang=pug"
import script from "./dualAxisChart.vue?vue&type=script&lang=coffee"
export * from "./dualAxisChart.vue?vue&type=script&lang=coffee"
import style0 from "./dualAxisChart.vue?vue&type=style&index=0&id=6d4d95e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4d95e8",
  null
  
)

export default component.exports